import DniValidator from '../utils/DniValidator.js';

class TasacionesCheckout extends TasacionesFunnelManager {

    constructor() {
        super({
            stepNumber: 5,
            nextStepUrl: TasacionesConf.completion_url || '/order-pay'
        });
        console.log("CHECKOUT STEP 5");
        this.formValidator = new FormValidator();
        this.dniValidator = DniValidator;
        this.initCheckoutElements();
        this.isRecoveryCheckout = this.elements.form?.dataset.checkoutContext === 'recovery';
        this.bindEvents();
        if (this.isRecoveryCheckout) return;
        this.initState();
        this.setTasacionCustomerName();
        this.setTasacionAddress();
    }

    initCheckoutElements() {
        this.elements = {
            form: document.getElementById('tasaciones-funnel-step-5'),
            
            billingDataSameRadios: document.querySelectorAll('input[name=tasaciones_checkout_billing_same]'),
            billingDataContainer: document.getElementById('tasaciones-checkout-billing-fields'),

            // Solicitante
            requesterNifTypeFieldContainer: document.getElementById('requester_nif_type_field'),
            requesterNifTypeField: document.getElementById('requester_nif_type'),
            requesterNifFieldContainer: document.getElementById('requester_nif_field'),
            requesterNifField: document.getElementById('requester_nif'),

            firstNameInput: document.getElementById('billing_first_name'),
            lastNameInput: document.getElementById('billing_last_name'),
            emailInput: document.getElementById('billing_email'),
            phoneInput: document.getElementById('billing_phone'),
            
            nifTypeFieldContainer: document.getElementById('billing_nif_type_field'),
            nifTypeField: document.getElementById('billing_nif_type'),
            nifFieldContainer: document.getElementById('billing_nif_field'),
            nifField: document.getElementById('billing_nif'),
            
            isCompany: document.getElementById('is_company'),
            cifTypeFieldContainer: document.getElementById('billing_cif_type_field'),
            cifTypeField: document.getElementById('billing_cif_type'),
            cifFieldContainer: document.getElementById('billing_cif_field'),
            cifField: document.getElementById('billing_cif'),
            companyFieldContainer: document.getElementById('billing_company_field'),
            companyField: document.getElementById('billing_company'),

            addressSameRadios: document.querySelectorAll('input[name=tasaciones_checkout_billing_address_same]'),
            addressSameDataContainer: document.getElementById('tasaciones-checkout-billing-fields-address-data'),

            address1Input: document.getElementById('billing_address_1'),
            address2Input: document.getElementById('billing_address_2'),
            postcodeInput: document.getElementById('billing_postcode'),
            cityInput: document.getElementById('billing_city'),
            stateSelect: document.getElementById('billing_state'),
            countrySelect: document.getElementById('billing_country'),

            donationCheckbox: document.getElementById('donation_enabled'),
            donationAmountInput: document.getElementById('donation_amount'),
        };
    }

    bindEvents() {
        if (this.elements.form) {
            this.elements.form.addEventListener('submit', (e) => this.handleSubmit(e));
        }
        if (this.isRecoveryCheckout) {
            this.elements.form.querySelector('[name=legal_terms_privacy]')?.addEventListener('change', (e) => this.validateFormField(e.target));
            return;
        }
        if (this.elements.billingDataSameRadios) {
            this.elements.billingDataSameRadios.forEach(radio => {
                radio.addEventListener('change', (e) => this.handleBillingDataSameChange(e));
            });
        }
        if (this.elements.isCompany) {
            this.elements.isCompany.addEventListener('change', (e) => this.handleIsCompanyChange(e));
        }
        if (this.elements.addressSameRadios) {
            this.elements.addressSameRadios.forEach(radio => {
                radio.addEventListener('change', (e) => this.handleAddressSameChange(e));
            });
        }
        if (this.elements.donationCheckbox) {
            this.elements.donationCheckbox.addEventListener('change', (e) => this.handleDonationChange(e));
        }
        if (this.elements.donationAmountInput) {
            this.elements.donationAmountInput.addEventListener('change', (e) => this.handleDonationAmountChange(e));
            this.elements.donationAmountInput.addEventListener('keyup', (e) => this.handleDonationAmountChange(e));
        }

        // Al teclear en requester_nif si el option de misma persona es "si" copiar el valor en billing_nif
        if (this.elements.requesterNifField) {
            this.elements.requesterNifField.addEventListener('keyup', (e) => {
                if (this.elements.billingDataSameRadios[0].checked) {
                    this.elements.nifField.value = e.target.value;
                }
            });
        }

        // Cambiar placeholder de requester_nif según el tipo seleccionado
        if (this.elements.requesterNifTypeField) {
            this.elements.requesterNifTypeField.addEventListener('change', (e) => {
                const placeholders = {
                    'nif': 'NIF *',
                    'nie': 'NIE *',
                    'otro': 'Documento de identidad *'
                };
                this.elements.requesterNifField.placeholder = placeholders[e.target.value] || 'NIF/NIE *';
            });
        }

        // Cambiar placeholder de billing_nif según el tipo seleccionado
        if (this.elements.nifTypeField) {
            this.elements.nifTypeField.addEventListener('change', (e) => {
                const placeholders = {
                    'nif': 'NIF *',
                    'nie': 'NIE *',
                    'otro': 'Documento de identidad *'
                };
                this.elements.nifField.placeholder = placeholders[e.target.value] || 'NIF/NIE *';
            });
        }

        // Cambiar placeholder de billing_cif según el tipo seleccionado
        if (this.elements.cifTypeField) {
            this.elements.cifTypeField.addEventListener('change', (e) => {
                const placeholders = {
                    'cif': 'CIF *',
                    'otro': 'Documento de identidad *'
                };
                this.elements.cifField.placeholder = placeholders[e.target.value] || 'CIF *';
            });
        }

        // Validar formulario cada vez que un campo pierde el foco
        if (this.elements.form) {
            this.elements.form.querySelectorAll('input, select').forEach(input => {
                input.addEventListener('blur', (e) => this.validateFormField(e.target));
                input.addEventListener('keyup', (e) => this.validateFormField(e.target));
                input.addEventListener('change', (e) => this.validateFormField(e.target));
            });
        }
    }

    initState() {
        if (this.elements.billingDataSameRadios){
            this.handleBillingDataSameChange({ target: this.elements.billingDataSameRadios[0]});
        }
        
        if (this.elements.isCompany) {
            this.handleIsCompanyChange({ target: this.elements.isCompany });
        }

        if (this.elements.addressSameRadios) {
            this.handleAddressSameChange({ target: this.elements.addressSameRadios[0]});
        }

        if (this.elements.requesterNifTypeField) {
            const requesterNifPlaceholders = {
                'nif': 'NIF *',
                'nie': 'NIE *',
                'otro': 'Documento de identidad *'
            };
            this.elements.requesterNifField.placeholder = requesterNifPlaceholders[this.elements.requesterNifTypeField.value] || 'NIF/NIE *';
        }

        if (this.elements.nifTypeField) {
            const nifPlaceholders = {
                'nif': 'NIF *',
                'nie': 'NIE *',
                'otro': 'Documento de identidad *'
            };
            this.elements.nifField.placeholder = nifPlaceholders[this.elements.nifTypeField.value] || 'NIF/NIE *';
        }

        if (this.elements.cifTypeField) {
            const cifPlaceholders = {
                'cif': 'CIF *',
                'otro': 'Documento de identidad *'
            };
            this.elements.cifField.placeholder = cifPlaceholders[this.elements.cifTypeField.value] || 'CIF *';
        }
    }

    validateFormField(field) {
        if (this.isRecoveryCheckout && field.name !== 'legal_terms_privacy') return;
        // Valida el formulario cada vez que un campo pierde el foco
        const formData = new FormData();
        formData.append(field.name, field.type === 'checkbox' && !field.checked ? '' : field.value);
        if (field.name == 'requester_nif') {
            formData.append('requester_nif_type', this.elements.requesterNifTypeField.value);
        }
        if (field.name == 'requester_nif_type') {
            formData.append('requester_nif', this.elements.requesterNifField.value);
        }
        if (field.name == 'billing_nif') {
            formData.append('billing_nif_type', this.elements.nifTypeField.value);
        }
        if (field.name == 'billing_nif_type') {
            formData.append('billing_nif', this.elements.nifField.value);
        }
        if (field.name == 'billing_cif') {
            formData.append('billing_cif_type', this.elements.cifTypeField.value);
        }
        if (field.name == 'billing_cif_type') {
            formData.append('billing_cif', this.elements.cifField.value);
        }
        if (field.name == 'billing_cif_type' || field.name == 'billing_cif' || field.name == 'billing_company') {
            formData.append('is_company', this.elements.isCompany.checked ? this.elements.isCompany.value : '0');
        }

        this.formValidator.validateCheckout(formData);
    }

    handleSubmit(e) {

        // Crear FormData del formulario
        // Recovery reuses saved billing data; only consent is editable here.
        // Keep the submitted form intact for WooCommerce and the payment gateway.
        const formData = this.isRecoveryCheckout ? new FormData() : new FormData(this.elements.form);
        if (this.isRecoveryCheckout) {
            const consent = this.elements.form.querySelector('[name=legal_terms_privacy]');
            formData.append('legal_terms_privacy', consent?.checked ? consent.value : '');
        }
        
        // Validar usando FormValidator
        const errors = this.formValidator.validateCheckout(formData);
        
        if (errors.length > 0) {
            e.preventDefault();
            return false;
        }
        
        return true;
    }

    handleIsCompanyChange(e) {
        console.log("IS COMPANY CHECKED", e.target.checked);
        if (e.target.checked) {
            this.elements.cifTypeFieldContainer.classList.remove('tasaciones-hidden');
            this.elements.cifFieldContainer.classList.remove('tasaciones-hidden');
            this.elements.companyFieldContainer.classList.remove('tasaciones-hidden');
            this.elements.cifField.required = true;
            this.elements.companyField.required = true;
            DOMHelpers.setValue(this.elements.cifField, '');
            DOMHelpers.setValue(this.elements.companyField, '');

            this.elements.nifTypeFieldContainer.classList.add('tasaciones-hidden');
            this.elements.nifFieldContainer.classList.add('tasaciones-hidden');
            
        } else {
            this.elements.cifTypeFieldContainer.classList.add('tasaciones-hidden');
            this.elements.cifFieldContainer.classList.add('tasaciones-hidden');
            this.elements.companyFieldContainer.classList.add('tasaciones-hidden');
            this.elements.cifField.required = false;
            this.elements.companyField.required = false;
            
            this.elements.nifTypeFieldContainer.classList.remove('tasaciones-hidden');
            this.elements.nifFieldContainer.classList.remove('tasaciones-hidden');
            DOMHelpers.setValue(this.elements.nifField, '');
        }
    }

    handleBillingDataSameChange(e) {
        if (!this.elements.billingDataSameRadios) return;
        const value = DOMHelpers.getRadioValue(this.elements.billingDataSameRadios);
        if (value === '0') {
            this.clearCustomerName();
            this.elements.billingDataContainer.classList.remove('tasaciones-hidden');
        } else {
            this.elements.billingDataContainer.classList.add('tasaciones-hidden');
            this.setTasacionCustomerName();
        }
    }

    handleAddressSameChange(e) {
        if (!this.elements.addressSameRadios) return;
        const value = DOMHelpers.getRadioValue(this.elements.addressSameRadios);
        if (value === '0') {
            this.clearCustomerAddress();
            this.elements.addressSameDataContainer.classList.remove('tasaciones-hidden');
        } else {
            this.elements.addressSameDataContainer.classList.add('tasaciones-hidden');
            this.setTasacionAddress();
        }
    }

    setTasacionCustomerName(){
        console.log("SET TASACION CUSTOMER NAME", TasacionesConf.order);
        if (TasacionesConf.order) {
            DOMHelpers.setValue(this.elements.firstNameInput, TasacionesConf.order.nombre);
            DOMHelpers.setValue(this.elements.lastNameInput, TasacionesConf.order.apellidos);
            DOMHelpers.setValue(this.elements.emailInput, TasacionesConf.order.email);
            DOMHelpers.setValue(this.elements.phoneInput, TasacionesConf.order.telefono);
            DOMHelpers.setValue(this.elements.nifTypeField, this.elements.requesterNifTypeField.value);
            DOMHelpers.setValue(this.elements.nifField, this.elements.requesterNifField.value);
        }
    }
    clearCustomerName(){
        DOMHelpers.setValue(this.elements.firstNameInput, '');
        DOMHelpers.setValue(this.elements.lastNameInput, '');
        DOMHelpers.setValue(this.elements.emailInput, '');
        DOMHelpers.setValue(this.elements.phoneInput, '');
        DOMHelpers.setValue(this.elements.nifTypeField, 'nif');
        DOMHelpers.setValue(this.elements.nifField, '');
        DOMHelpers.setValue(this.elements.cifTypeField, 'cif');
        DOMHelpers.setValue(this.elements.cifField, '');
        DOMHelpers.setValue(this.elements.companyField, '');
    }

    setTasacionAddress(){
        console.log("SET TASACION ADDRESS", TasacionesConf.order);
        if (TasacionesConf.order) {
            if (TasacionesConf.order.dir_nombre_via && TasacionesConf.order.dir_numero){
                DOMHelpers.setValue(this.elements.address1Input, (TasacionesConf.order.dir_tipo_via ? TasacionesConf.order.dir_tipo_via + ' ' : '') + TasacionesConf.order.dir_nombre_via + ' ' + TasacionesConf.order.dir_numero);
            } else {
                DOMHelpers.setValue(this.elements.address1Input, '');
            }
            if (TasacionesConf.order.dir_escalera && TasacionesConf.order.dir_planta && TasacionesConf.order.dir_puerta){
                DOMHelpers.setValue(this.elements.address2Input, TasacionesConf.order.dir_escalera + ' ' + TasacionesConf.order.dir_planta + ' ' + TasacionesConf.order.dir_puerta);
            } else {
                DOMHelpers.setValue(this.elements.address2Input, '');
            }

            DOMHelpers.setValue(this.elements.postcodeInput, TasacionesConf.order.codigo_postal);
            DOMHelpers.setValue(this.elements.cityInput, TasacionesConf.order.municipio);
            DOMHelpers.setSelectValueFlexible(this.elements.stateSelect, TasacionesConf.order.provincia);
            DOMHelpers.setSelectValueFlexible(this.elements.countrySelect, 'ES');
            console.log("Cambio dirección: ", TasacionesConf.order);
            console.log("Cambio dirección2: ", this.elements.cityInput);
            console.log("Cambio dirección2: ", this.elements.cityInput.value);
        }
    }
    clearCustomerAddress(){
        DOMHelpers.setValue(this.elements.address1Input, '');
        DOMHelpers.setValue(this.elements.address2Input, '');
        DOMHelpers.setValue(this.elements.cityInput, '');
        DOMHelpers.setValue(this.elements.postcodeInput, '');
        DOMHelpers.setSelectValueFlexible(this.elements.stateSelect, '');
        DOMHelpers.setSelectValueFlexible(this.elements.countrySelect, 'ES');
    }

    handleDonationChange(e) {
        if (e.target.checked) {
            DOMHelpers.setDisabled(this.elements.donationAmountInput, false);
        } else {
            DOMHelpers.setDisabled(this.elements.donationAmountInput, true);
        }
        this.updateCheckout();
    }

    handleDonationAmountChange(e) {
        this.normalizeAmount();

        this.updateCheckout();
    }

    updateCheckout(){
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
        }
        this.updateTimeout = setTimeout(() => {
            document.body.dispatchEvent(new CustomEvent('update_checkout'));
        }, 1000);
    }

    normalizeAmount() {
        var val = parseInt(this.elements.donationAmountInput.value, 10);
        if (isNaN(val) || val < 1) {
            DOMHelpers.setValue(this.elements.donationAmountInput, 1);
        }
    }
}

window.TasacionesCheckout = TasacionesCheckout;